<template>
  <div class="form-group">
    <label
      v-if="label"
      :for="inputId"
      :class="`col-sm-${+labelCols} ${!previewMode && 'control-label'}`"
      >{{ label }}</label
    >
    <div :class="label ? `col-sm-${12 - +labelCols}` : ''">
      <BaseDatepicker
        v-if="!previewMode"
        :value="value"
        :disabled="disabled"
        :type="type"
        :error="error"
        @input="$emit('input', $event)"
      />
      <template v-else>{{ value }}</template>
      <div v-if="error" class="error-message">{{ error }}</div>
    </div>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
import BaseDatepicker from './BaseDatepicker';

export default {
  name: 'BaseFormDatepicker',

  components: { BaseDatepicker },

  props: {
    value: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    labelCols: {
      type: [Number, String],
      default: 6,
    },
    type: {
      type: String,
      default: 'date',
    },
    valueFormat: {
      type: String,
      default: 'YYYY-MM-DD',
    },
    previewMode: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      inputId: '',
    };
  },

  created() {
    this.inputId = this.id || uuidv4();
  },
};
</script>
